import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Typography } from '@saviynt/design-system';

import { getMessageKey } from '../../utils/utils';

import { ARS_ID_FOR_EVENT } from './constant';

import './AccessRequestHistory.css';

function AccessRequestHistoryButton() {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);

  return (
    <Box tag='div' id={ARS_ID_FOR_EVENT}>
      <Typography kind='body2-bold' className='AccessRequestHistoryBtn'>
        {messages['ARS.button.label.ATTESTATIONS'] ||
          localize(intl, getMessageKey('ARS.button.label'))}
      </Typography>
    </Box>
  );
}

export default AccessRequestHistoryButton;
